const scrollToAnchor = (id, offset = 0) => {
  const element = document.getElementById(id);
  if (element) {
    const heightToDiv = element?.getBoundingClientRect().top - offset + window.scrollY;
    window.scroll({
      top: heightToDiv,
      behavior: 'smooth'
    });
  }
};
export { scrollToAnchor };
//# sourceMappingURL=scrollToAnchor.js.map
